import {
    COLUMN_GROUPS as OPS_COLUMN_GROUPS,
    DEFAULT_VISIBLE as OPS_DEFAULT_VISIBLE,
} from "../../../ops/pages/orders-legacy/columnPrefs";


export const COLUMN_GROUPS = [
    ...OPS_COLUMN_GROUPS,
    {
        label: "Sales finance",
        columns: [
            { id: "outstandingAmount", label: "Outstanding(₹)" },
            { id: "discountPercentage", label: "Discount %" },
            { id: "evitalOrderNumber", label: "Evital No" },
            { id: "evitalPrintUrl", label: "Evital Invoice" },
            { id: "paymentGateway", label: "Payment Gateway" },
            { id: "paymentMethod", label: "Payment Method" },
            { id: "paymentSource", label: "Payment Source" },
            { id: "paymentStatus", label: "Payment Status" },
        ],
    },
    {
        label: "Sales attribution",
        columns: [{ id: "salesPerson", label: "Sales Person" }],
    },
];

export const ALL_HIDEABLE_IDS = COLUMN_GROUPS.flatMap((group) => group.columns.map((column) => column.id));

const SALES_ADDED_IDS = COLUMN_GROUPS.filter(
    (group) => !OPS_COLUMN_GROUPS.includes(group)
).flatMap((group) => group.columns.map((column) => column.id));
export const DEFAULT_VISIBLE = [...OPS_DEFAULT_VISIBLE, ...SALES_ADDED_IDS];

// Deliberately its OWN key, distinct from ops' "pillup.ops.orders.columns": the two
// consoles have different column catalogues, so sharing a key would let a choice made in
// one silently hide columns in the other.
const STORAGE_KEY = "pillup.sales.orders.columns";
const STORAGE_VERSION = 1;

export function defaultHiddenColumns() {
    return ALL_HIDEABLE_IDS.filter((id) => !DEFAULT_VISIBLE.includes(id));
}

/**
 * The user's stored hidden-column ids, or the default set. Never throws: localStorage can
 * be unavailable (private mode, disabled storage) and the stored value can be malformed.
 * A column preference is not worth failing a page render over.
 */
export function loadHiddenColumns() {
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return defaultHiddenColumns();
        const parsed = JSON.parse(raw);
        if (!parsed || parsed.version !== STORAGE_VERSION || !Array.isArray(parsed.hidden)) {
            return defaultHiddenColumns();
        }
        // Drop ids that no longer exist, so a renamed column cannot leave a stale entry.
        return parsed.hidden.filter((id) => ALL_HIDEABLE_IDS.includes(id));
    } catch (error) {
        return defaultHiddenColumns();
    }
}

/** Persist the hidden-column ids. Silently no-ops if storage is unavailable. */
export function saveHiddenColumns(hidden) {
    try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ version: STORAGE_VERSION, hidden }));
    } catch (error) {
        // Ignored on purpose -- the choice still applies for this session.
    }
}
